(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/competition/core/assets/javascripts/get-draw.js') >= 0) return;  svs.modules.push('/components/competition/core/assets/javascripts/get-draw.js'); 'use strict';

svs.competition.core.getDraw = function (productId, drawNumber, callback) {
  if (svs.utils.ns.isNamespace('svs.competition.core.data.tipsSMCompetition')) {
    var path = '/draw/';

    switch (productId) {
      case 'ITA':
        path += 'europatipset';
        break;

      case 'STRYK':
        path += 'stryktipset';
        break;

      default:
    }

    path += "/draws/".concat(drawNumber);
    svs.core.jupiter.get(path, function (data) {
      return callback(null, data);
    }, function (err) {
      return callback(err);
    });
  }
};
 })(window);